import { httpsCallable } from 'firebase/functions';
import { functions } from '@/lib/firebase';
import { tratarErroDeCallable } from '@/lib/erros';

/**
 * ★ PC-7 — as frases que mais chegaram como 1ª mensagem (aba Captação).
 *
 * É callable, e não leitura do navegador, por LGPD: o servidor lê as mensagens e devolve só o texto
 * que chegou igual de 5+ leads diferentes. O texto de uma pessoa nunca chega à tela.
 * Só o gestor (o servidor recusa os demais papéis).
 *
 * @returns `{ janelaDias, minimo, analisados, frases: [{ frase, leads, palavras, motivo }] }`
 */
/** ★ WT: toda callable passa pelo ponto único que registra o `code` do servidor e relança. */
const chamarCallable = (nome) => async (dados) => {
  try {
    return await httpsCallable(functions, nome)(dados);
  } catch (erro) {
    throw tratarErroDeCallable(nome, erro);
  }
};

export async function buscarFrasesFrequentes(clinicaId) {
  const { data } = await chamarCallable('frasesFrequentesCaptacao')({ clinicaId });
  return data;
}
